<template >
  <div>
    <Banner />
    <PdkHeader />

    <main>
      <div class="search-widget">
        <carousel class="d-none d-md-block" :items="1" :dots="false" :nav="false" :autoplay="true" :smartSpeed="2500"
          :autoplayTimeout="8500" dir="ltr">
          <img src="/img/etr7333r copy_dariushgroup.jpg" />
          <img src="/img/0sac5c_dariushgroup.jpg" />
        </carousel>

        <div class="mobiletop-banner d-md-none">
          <img src="/img/cmolp12.jpg" />
        </div>
        <div id="search_2">
          <div class="search-title">
            <!-- <h2>سامانه رزرواسیون پردیس داریوش کیش</h2> -->
          </div>

          <div class="search-box">
            <ul class="nav nav-tabs reserve-explorer">
              <li class="reserve-explorer-item">
                <div href="#tours" data-toggle="tab" class="btn_tab active show reserve-explorer-tab">
                  <svg class="hotef" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 846.89 380.67"
                    style="enable-background: new 0 0 846.89 380.67" xml:space="preserve">
                    <path
                      d="M433.55,272.79c-3.73,0-7.26-2.21-8.78-5.87c-2.01-4.85,0.29-10.4,5.14-12.41l49.1-20.35l-15.42-23.54  c-2.27-3.3-15.88-24.01-9.05-34.78c2.66-4.19,7.56-6.14,12.79-5.08c6.77,1.36,12.94,2.71,18.91,4.01  c32.39,7.07,51.94,11.34,85.31,0.13c1.12-0.38,2.13-0.59,2.87-0.74c0.17-0.04,0.35-0.07,0.52-0.11  c156-80.47,201.72-50.95,214.13-34.5c7.1,9.41,7.81,20.96,1.68,27.47c-19.58,20.83-90.75,46.26-98.8,49.09  c-4.95,1.74-10.37-0.86-12.11-5.81s0.86-10.37,5.81-12.11c20.18-7.1,74.71-28.35,90.21-43.12c-0.27-1.51-1.64-4.9-6.37-8.21  c-10.02-7-53.06-24.48-186.16,44.24c-1.97,1.02-3.81,1.4-5.03,1.66c-0.24,0.05-0.49,0.09-0.73,0.16  c-38.32,12.87-62.25,7.64-95.38,0.41c-2.51-0.55-5.05-1.1-7.65-1.66c1.38,2.93,3.06,5.96,4.63,8.07c0.11,0.15,0.22,0.3,0.32,0.46  l16.96,25.88l9.31-2.97c4.85-1.54,10.06,1,11.81,5.79c1.75,4.78-0.58,10.09-5.29,12.04l-75.09,31.11  C436,272.56,434.77,272.79,433.55,272.79z" />
                    <path
                      d="M477.56,299.9c-3.79,0-7.37-2.28-8.84-6.02c-1.92-4.88,0.48-10.4,5.36-12.32l74.62-29.4c4.88-1.92,10.4,0.48,12.32,5.36  c1.92,4.88-0.48,10.4-5.36,12.32l-74.62,29.4C479.9,299.68,478.72,299.9,477.56,299.9z" />
                    <path
                      d="M629.87,295.5c-8.56,0-16.82-4.56-21.19-12.39l-30.2-54.1c-2.56-4.58-0.92-10.37,3.67-12.92  c4.58-2.56,10.37-0.92,12.92,3.67l30.2,54.1c1.26,2.26,4.03,3.25,6.44,2.3l10.19-4.02c2.96-1.17,4.94-4.09,4.92-7.27l-0.52-75.27  c-0.04-5.25,4.19-9.53,9.43-9.57c0.02,0,0.05,0,0.07,0c5.22,0,9.46,4.21,9.5,9.43l0.52,75.27c0.08,10.98-6.74,21.06-16.95,25.08  l-10.2,4.02C635.81,294.96,632.82,295.5,629.87,295.5z" />
                    <path class="st0" d="M575.53,149.13" />
                    <path
                      d="M575.53,158.63c-0.76,0-1.54-0.09-2.31-0.29c-5.09-1.27-8.19-6.43-6.91-11.52l10.48-41.93c1.63-6.51,6.33-11.87,12.58-14.33  l21.56-8.49c5.18-2.04,10.92-1.63,15.75,1.11c4.77,2.71,8.05,7.34,9,12.73l7.34,35.66c1.06,5.14-2.25,10.16-7.39,11.22  c-5.13,1.06-10.16-2.25-11.22-7.39l-7.28-35.36l-20.8,8.2c-0.55,0.22-0.97,0.69-1.11,1.26l-10.48,41.93  C583.66,155.75,579.79,158.63,575.53,158.63z" />
                    <path
                      d="M360.19,327.62h-41.7c-5.25,0-9.5-4.25-9.5-9.5s4.25-9.5,9.5-9.5h39.69V161.88h-60.13v148.76c0,9.37-7.62,16.99-16.99,16.99  H142.05c-1.12,0-2.19-0.19-3.19-0.55c-1.37,0.36-2.81,0.55-4.29,0.55H72.55c-9.37,0-16.99-7.62-16.99-16.99V162  c0-9.37,7.62-16.99,16.99-16.99h32.08c5.25,0,9.5,4.25,9.5,9.5s-4.25,9.5-9.5,9.5H74.56v144.6h57.99V70.04  c0-9.37,7.62-16.99,16.99-16.99h131.52c9.37,0,16.99,7.62,16.99,16.99v45.98c0,5.25-4.25,9.5-9.5,9.5s-9.5-4.25-9.5-9.5V72.05  h-127.5v236.56h24.84v-53.59c0-9.37,7.62-16.98,16.98-16.98h42.77c9.37,0,16.99,7.62,16.99,16.98v53.59h25.91V159.86  c0-9.37,7.62-16.99,16.99-16.99h64.16c9.37,0,16.99,7.62,16.99,16.99v150.77C377.18,320,369.56,327.62,360.19,327.62z   M195.39,308.62h38.74v-51.57h-38.74V308.62z M328.82,253.84c-5.25,0-9.5-4.25-9.5-9.5v-49.9c0-5.25,4.25-9.5,9.5-9.5  s9.5,4.25,9.5,9.5v49.9C338.32,249.58,334.07,253.84,328.82,253.84z M104.98,253.84c-5.25,0-9.5-4.25-9.5-9.5v-49.9  c0-5.25,4.25-9.5,9.5-9.5s9.5,4.25,9.5,9.5v49.9C114.48,249.58,110.23,253.84,104.98,253.84z M195.87,191.61  c-0.47,0-0.94-0.04-1.42-0.11c-5.19-0.78-8.76-5.62-7.99-10.8c1.26-8.43,9.66-8.59,15.22-8.69c3.26-0.06,7.75-0.04,13.35,0.07  c9.41,0.18,18.91,0.54,19.01,0.54c5.24,0.2,9.33,4.61,9.13,9.85c-0.2,5.24-4.61,9.35-9.85,9.13c-13.6-0.52-29.92-0.83-34.42-0.49  C197.94,191.43,196.92,191.61,195.87,191.61z M205.25,183.53c-0.08,0.5-0.19,0.99-0.34,1.46  C205.06,184.53,205.17,184.04,205.25,183.53z M177.61,131.74c-0.89,0-1.79-0.13-2.69-0.39c-5.03-1.48-7.91-6.76-6.43-11.8  c1.99-6.74,8.49-7.05,11.98-7.21c2.1-0.1,4.99-0.17,8.83-0.2c6.24-0.06,14.89-0.04,25.71,0.07c18.36,0.18,36.91,0.53,37.09,0.54  c5.25,0.1,9.42,4.44,9.31,9.68c-0.1,5.25-4.44,9.45-9.68,9.31c-30.83-0.6-65.19-0.88-71.54-0.36  C179.37,131.62,178.5,131.74,177.61,131.74z M186.72,124.94c-0.32,1.07-0.81,2.05-1.43,2.9  C185.88,127.02,186.38,126.06,186.72,124.94z" />
                  </svg>
                  <span>هتل + پرواز</span>
                </div>
              </li>
            </ul>

            <PdkSearch :selectedDestination="onSelectedDest" :originList="originList" :destinationList="destinations" />
            <!-- <flight-search
              v-if="tabIndex == 3"
              :selectedHotel="onSelectedHotel"
              :selectedDestination="onSelectedDest"
              :originList="originList"
              :destinationList="originList"
            /> -->
          </div>
        </div>
      </div>

      <div class="container-fluid about-pardis-dariush">
        <svg xmlns="http://www.w3.org/2000/svg" class="curved-shape1 fix-shap-footer" fill="#f5f7f9" id="Layer_1"
          data-name="Layer 1" viewBox="0 0 1500 154.5">
          <path class="cls-1"
            d="M0,117.11v62H1500v-62s0-90.59-101.4-92c-91.07-1.28-546.32.37-681.5.37-127.36,0-507.58-.32-618.77-.37C0,25.05,0,117.11,0,117.11Z"
            transform="translate(0 -24.61)" />
        </svg>
      </div>

      <div class="container-fluid margin_container">
        <div class="second_title">
          <h2>تورهای <span class="dest-list-title">پیشنهادی</span> ما</h2>
        </div>
        <div class="row">
          <div v-for="(item, index) in destinationList" v-bind:key="index" style="padding: 15px !important; z-index: 99;"
            class="col-lg-4 col-sm-6 mb-3 mb-lg-0 px-0">
            <div class="hover hover-1 text-white fullrow">
              <img style="width: 100% !important; height: 100% !important" :src="
                item.location.locationImages[0]
                  ? item.location.locationImages[0].imageUrl
                  : 'img/tour_box_1.jpg'
              " />
              <div class="hover-overlay"></div>
              <div @click="onSelectDestination(item)" class="hover-1-content px-5 py-4">
                <span class="tooltip-content-flip"><span class="tooltip-back">انتخاب به عنوان مقصد</span></span>
                <h3 class="hover-1-title text-uppercase mb-0">
                  {{ item.title }}
                </h3>
                <p class="hover-1-description font-weight-light mb-0">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PdkToTop/>
    </main>

    <PdkFooter />
  </div>
</template>

<script>
import Banner from "@/components/tour/TourBanner";
import PdkSearch from "@/components/tour/Search";
import PdkHeader from "@/components/PdkHeader";
import Store from "../tour/store/index";
import PdkFooter from "@/components/PdkFooter";
import FlightSearch from "../../components/flight/FlightSearch";
import carousel from "vue-owl-carousel2";
import PdkToTop from "@/components/PdkToTop"

require("linqjs");

export default {
  name: "flightHotels",
  store: Store,
  components: {
    Banner,
    PdkSearch,
    PdkHeader,
    PdkFooter,
    FlightSearch,
    carousel,
    PdkToTop
  },

  data: () => ({
    isResultNotFound: false,
    destinations: [],
    originList: {},
    destinationList: {},
    specialDestination: {},
    tourAccessibility: false,
    flightAccessibility: false,
    isMobile: true,
  }),
  async created() {
    this.getDestinationList();
    this.getLocationList();
  },

  mounted: function () {
    // this.isMounted = true;
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });

  },

  computed: {


    onSelectedDest: function () {
      return this.selectedDest;
    },
    // checkSourceId() {
    //   if (localStorage.getItem("SourceIdInReport") !== null) {
    //     this.tabIndex = 1;
    //     return true;
    //   } else {
    //     this.tabIndex = 10;
    //     return false;
    //   }
    // },
    // getAccessibility() {
    //   // this.mainSearchAccessibility = this.$store.getters.GetMenuList;
    //   this.checkMenuList = false;
    //   if (localStorage.getItem("menuList") !== null)
    //     this.$store.dispatch("changeMenuItemStatus", true);

    //   const checkValue = this.$store.getters.GetMenuItemStatus;
    //   if (checkValue === true) this.checkMenuList = true;

    //   if (this.checkMenuList === true) {
    //     this.mainSearchAccessibility = JSON.parse(
    //       localStorage.getItem("menuList")
    //     );
    //     let currentTab = 1;

    //     const checkHomeLength = this.mainSearchAccessibility.filter(
    //       (p) => p.name === "homeSearch"
    //     );

    //     if (
    //       this.mainSearchAccessibility.length != 0 &&
    //       checkHomeLength.length != 0
    //     ) {
    //       this.mainSearchAccessibility = this.mainSearchAccessibility.filter(
    //         (p) => p.name === "homeSearch"
    //       )[0].children;

    //       if (
    //         this.mainSearchAccessibility.filter((p) => p.name === "hotelFlight")
    //           .length
    //       ) {
    //         this.tourCurrentTab = currentTab;
    //         this.tourAccessibility = true;
    //       }
    //     }
    //     return this.checkMenuList;
    //   }
    // },
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 600;
    },


    async getDestinationList() {
      const destinations = await this.$store.dispatch(
        "unauthorized/GetDestinationList"
      );

      if (Array.isArray(destinations)) {
        this.destinationList = destinations;
        this.specialDestination = destinations.where(
          (d) => d.location.isoCode == "KIH"
        );
      }
    },
    async getLocationList() {
      this.originList = await this.$store.dispatch("unauthorized/getLocations");

      // redtrict destinations
      this.destinations = this.originList.data.filter(
        (p) => p.iata == "KIH" || p.iata == "MHD"
      );

      //redtrict cities
      this.cities = this.originList.data.filter(
        (p) =>
          p.type == "City" &&
          (p.iata == "KIH" || p.iata == "MHD" || p.iata == "SYZ")
      );
    },
  },
};
</script>

<style lang="css" scoped>
.nav-tabs {
  border-bottom: none !important;
}

.search-widget .custom-search-input-2 {
  background-color: rgba(255, 255, 255, 0.88);
  border-radius: 0 0 30px 30px;
}

.search-title {
  color: #175488;
  font-size: 28px;
  font-weight: 700;
}
.tooltip-content-flip .tooltip-back::after {
  left: 45%;
  border-top: 0px solid transparent !important;
  /* border-right: 10px solid transparent; */
}

.tooltip-content-flip {
  position: absolute;
  z-index: 9;
  width: 80px;
  height: 45px;
  right: -240% !important;
  top: -27% !important;
  text-align: center;
  color: #fff;
  opacity: 0;
  margin-top: 7px !important;
  background: #00c3e1 !important;
  border-radius: 20px;
  cursor: default;
  pointer-events: none;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;
  transition: opacity 0.3s, transform 0.3s;
}

.tooltip-back {
  padding: 5px;
  background: #00c3e1;
  border: 2px solid #11567896;
  border-radius: 5px !important;
  font-size: 12px;
  /* line-height: 14px; */
  /* padding-top: 25px; */
  -webkit-transform-origin: 0 50%;
  transform-origin: 0 50%;
  -webkit-transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
  transform: perspective(1000px) rotate3d(0, 1, 0, 90deg);
}
.search-widget {
  position: relative;
}

.margin_container {
  padding: 1% 8%;
}

.hover {
  overflow: hidden;
  position: relative;
  padding-bottom: 60%;
}

.fullrow {
  height: 100% !important;
  border-radius: 20px;
}

.hover-overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 90;
  transition: all 0.4s;
}

.hover img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s;
  height: fit-content;
  width: fit-content !important;
}

.hover-1 img {
  width: 105%;
  position: absolute;
  top: 0;
  left: 0%;
  transition: all 0.3s;
}

.hover-1-content {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  transition: all 0.4s;
  cursor: pointer;
}

.hover-1 .hover-overlay {
  background: rgba(213, 171, 61, 0.7);
  opacity: 0;
}

.hover-1-description {
  transform: translateY(0.5rem);
  transition: all 0.4s;
  opacity: 0;
}

.hover-1:hover .hover-1-content {
  bottom: 2rem;
}

.hover-1:hover .hover-1-description {
  opacity: 1;
  transform: none;
}

.hover-1:hover img {
  left: 0;
}

.hover-1:hover .hover-overlay {
  opacity: 1;
}

.hover-1-content h3 {
  color: rgb(255, 240, 240);
  text-shadow: 2px 2px 1px #2a2a2a, 0px 5px 3px #20333c;
}

.btn_tab {
  width: 87px;
  height: 50px;
  text-align: center;
  background: #b4b3b3;
  color: #fefefe;
  border-radius: 6px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.btn_tab:hover {
  background: #90908f;
}

#eeb61f .btn_tab div {
  font-size: 16px;
  text-align: center;
}

.search-title {
  text-align: center;
  margin-bottom: 0;
  /* margin-top: 10%; */
}

.search-title h2 {
  color: #3c5eb3;
  font-size: 28px;
  font-weight: 700;
}

.search-box {
  padding: 5% 7% 5% 12%;
  border-radius: 10px;
}

.reserve-explorer {
  color: #444;
}

.reserve-explorer-item {
  border-bottom: none !important;
  width: 100%;
}

.reserve-explorer-item:first-child .reserve-explorer-tab {
  border-radius: 25px 25px 0 0;
}

.reserve-explorer-item:last-child .reserve-explorer-tab {
  border-radius: 25px 25px 0 0;
}

.reserve-explorer-item .reserve-explorer-tab {
  background: #fcbe2f;
  color: #000;
  border-bottom: 0 !important;
  width: 100% !important;
  padding-top: 10px;
}

.reserve-explorer-item .reserve-explorer-tab.active_tab {
  background: #fafbfb  !important;
  padding-top: 10px;
}

.reserve-explorer-item .reserve-explorer-tab:hover {
  background: #ede6d7;
  cursor: pointer;
}

.reserve-explorer-item svg {
  width: 31px;
}

.reserve-explorer-item svg.hotef {
  width: 66px;
}

.reserve-explorer-item span {
  font-size: 17px;
  font-weight: 500;
  margin-right: 5px;
  vertical-align: sub;
}

.about-pardis-dariush {
  padding: 0 10% 50px;
  position: relative;
}
.about-pardis-dariush .main_title {
  z-index: 999;
  display: flex;
  padding-top: 40px;
  margin-bottom: 20px;
  margin-right: 10px;
  position: relative;
}

.about-pardis-dariush .main_title h2 {
  z-index: 999;
  margin-top: 0;
  margin-bottom: 15px;
}

.about-pardis-dariush .about-pardis-right {
  padding: 0 10px 10px 7%;
  z-index: 100;
}

.about-pardis-dariush .about-pardis-right h3 {
  font-size: 25px;
  font-weight: 600;
}

.about-pardis-dariush .about-pardis-right p {
  font-size: 16px;
  font-weight: 200;
  line-height: 2;
  margin: 15px 6px;
  text-align: justify;
}

.about-pardis-dariush .about-pardis-left {
  padding: 10px 15px 30px;
  z-index: 100;
}

.about-pardis-dariush .about-pardis-left .about-counter .counter-item {
  text-align: center;
  border: 2px dashed #dde3e9;
  padding: 55px 5px 30px;
  margin: 8px 20px 0;
  position: relative;
  border-radius: 7px;
}

.about-pardis-dariush .about-pardis-left .about-counter .counter-item h4 {
  font-size: 16px;
  line-height: 1.6;
}

.about-pardis-dariush .about-pardis-left .about-counter .first-link .counter-item::before {
  content: " ";
  position: absolute;
  width: 60px;
  height: 150px;
  background-image: url(/img/persepoliscolumns3.svg);
  background-size: contain;
  right: -50%;
  background-repeat: no-repeat;
  top: 58px;
}

.about-pardis-dariush .about-pardis-left .about-counter .col-lg-4 {
  padding: 20px !important;
}

.about-pardis-dariush .about-pardis-left .about-counter .col-lg-4:nth-child(7) .counter-item::after {
  content: " ";
  position: absolute;
  width: 65px;
  height: 150px;
  background-image: url(/img/persepoliscolumns3.svg);
  background-size: contain;
  left: -50%;
  background-repeat: no-repeat;
  top: -115px;
}

.about-pardis-dariush .about-pardis-left .about-counter .counter-item .icon {
  font-size: 32px;
  margin: 0px 0 25px;
  color: #00c3e1;
  position: absolute;
  right: 32%;
  top: -32px;
  border-radius: 50%;
  background: #fafbfc;
  height: 70px;
  width: 70px;
  margin: 0;
  border: 2px dashed #b6bec5;
  border-bottom: none;
  line-height: 2.1;
}

.about-pardis-dariush .about-pardis-left .about-counter .counter-item a {
  color: #32325d;
}
.second_title{
  margin-top: -144px;
    z-index: 99;
}

#hotels {
  box-shadow: none !important;
}

@media (max-width: 350px) {

  .about-pardis-dariush .curved-shape1 {
    top: -137px !important;
  }

  #header_menu {
    padding: 20px 25px !important;
  }

  .search-title h2 {
    font-size: 17px;
    margin-top: 50px;
  }
}

@media (max-width: 575.99px) {
  .search-box {
    z-index: 9999;
  }

  .about-pardis-dariush.hotels-list-carousel {
    padding: 0 3%;
  }

  .about-pardis-dariush .main_title h2 {
    margin-top: 0;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .col-lg-4:nth-child(odd) {
    padding-right: 25px !important;
    padding-left: 5px !important;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .col-lg-4:nth-child(even) {
    padding-left: 25px !important;
    padding-right: 5px !important;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .counter-item {
    text-align: center;
    padding: 35px 4px 20px;
    margin: 5px -10px;
    position: relative;
    border-radius: 18px;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .counter-item .icon {
    font-size: 25px;
    margin: 0 0 25px !important;
    right: 31%;
    top: -30px;
    border-radius: 50%;
    height: 55px;
    width: 55px;
    border-bottom: none;
    margin: 0;
    line-height: 2.3;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .first-link .counter-item::before {
    width: 60px;
    height: 150px;
    right: -39%;
    top: 85px;
  }

  .about-pardis-dariush .about-pardis-left .about-counter .col-lg-4:last-child .counter-item[data-v-5e7337c8]::after {
    width: 60px;
    height: 150px;
    left: -41%;
    top: -51px;
  }

  .about-pardis-dariush .about-pardis-left h4 {
    font-size: 14px;
  }

  .about-pardis-dariush .curved-shape1 {
    top: -35px !important;
    z-index: 2 !important;
  }

  .search-title h2 {
    font-size: 20px;
    margin-top: 70px;
  }

  .search-title {
    color: #175488;
    font-size: 18px;
    font-weight: bold;
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .about-pardis-dariush .curved-shape1 {
    top: 0;
  }

  .search-title h2[data-v-5e7337c8] {
    font-size: 23px;
    margin-top: 80px;
  }

  #search_2 {
    width: 100% !important;
  }

  .search-box {
    z-index: 9999;
  }

  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -56px !important;
  }
}

/* Small devices (landscape phones, 991px and up)*/


/* Styles for extra samll phones */

/* Medium devices (tablets, 1199px and up)*/
@media (min-width: 992px) and (max-width: 1199px) {
  .search-title {
    color: #175488;
    font-size: 30px;
    font-weight: 700;
  }
}

/* Large devices (desktops, 1200px and up) */
@media (min-width: 1200px) {
  .search-title {
    color: #175488;
    font-size: 26px;
    font-weight: 700;
  }

  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -10px;
    width: 100%;
    right: 0;
    z-index: 99;
  }

  .fix-shap-footer {
    position: absolute !important;
    top: -100px !important;
  }

}

/* just Nest Hub */
@media all and (device-width: 1024px) and (device-height: 600px) {
  .search-title {
    font-size: 25px;
    font-weight: 700;
  }
  .about-pardis-dariush .curved-shape1 {
    position: absolute;
    top: -30px !important;
  }
}

/*  Nest Hub Max */
@media all and (device-width: 1280px) and (device-height: 800px) {
  .search-box-co {
    position: absolute !important;
    bottom: 140px;
    right: 215px;
  }

}
@media only screen and ( max-width:1442px) {
    .second_title {
    margin-top: -113px;
    z-index: 99;
}
    
  }
  @media only screen and ( max-width: 1025px ) {
    .second_title {
    margin-top: -9px;
      }
  }
</style>

